import React, { FC } from 'react'
import imgSrc from '../../assets/errors/50X.svg'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { Link } from '@mui/material'
import { Text } from './styled'

const Error500: FC = () => {
	return (
		<Box
			display={'flex'}
			flexDirection={'column'}
			alignItems={'center'}
			maxWidth={'30rem'}
			minWidth={'10.86rem'}
		>
			<img src={imgSrc} alt={''} loading={'lazy'} width={174} />
			<Text paragraph mt={7} mb={0} lineHeight={1}>
				We’re having some issues
			</Text>
			<Text paragraph>Time to take a 5 minute break and reload the page</Text>
			<Text paragraph mb={3}>
				If this issue continues please contact us at
				<br />
				<Link
					href={'mailTo:https://engage.support@dariohealth.com'}
					underline={'hover'}
					target={'_blank'}
				>
					engage.support@dariohealth.com
				</Link>
			</Text>
			<Button
				size={'large'}
				variant='contained'
				color={'primary'}
				sx={{ maxWidth: '5.69rem' }}
			>
				Reload
			</Button>
		</Box>
	)
}

export default Error500
